<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col class="text-center">
        <span class="text-info d-inline-block mr-2" v-b-tooltip.hover :title="tooltip">
          <i class="fa fa-question-circle"></i>
        </span>
        <h4 class="font-weight-bold d-inline-block">
          {{title}}
          <small>
            ({{is_preview ? 'プレビュー' : description}})
          </small>
        </h4>
      </b-col>
    </b-row>
    <hr v-if="!is_preview || is_preview === false">
    <b-row v-if="!is_preview || is_preview === false">
      <b-col>
        <!-- 정책 -->
        <b-input @keyup.enter="append" :state="Boolean(item.policy)" style="width: 100%;" type="text" placeholder="* 条件を入力してください" v-model="item.policy"></b-input>
      </b-col>
      <b-col>
        <!-- 모드 -->
        <b-dropdown style="width: 100%;height: 50px;border: 1px solid gray; border-radius: 12px; " :text="codes.WAF_MODE_I18N(item.mode, 'EN')" size="sm" :variant="codes.WAF_MODE_TO_COLOR(item.mode, 'variant')">
          <!-- 영문 기준으로 모드 설정 필요 -->
          <b-dropdown-item
            size="sm"
            @click="() => { item.mode_origin = !item.mode_origin ? codes.WAF_MODE_I18N(item.mode, 'EN') : item.mode_origin;  item.is_change = codes.WAF_MODE_I18N(item.mode_origin, 'EN') != x; item.mode = codes.WAF_MODE_INTERFACE(x); }"
            v-for="(x, sindex) in codes.WAF_MODE"
            :key="'_mode'+sindex"
          >{{codes.WAF_MODE_I18N(x, 'EN')}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col>
        <!-- 위험도 -->
        <b-dropdown style="width: 100%;height: 50px;border: 1px solid gray; border-radius: 12px; " :text="codes.WAF_SEVERITYS_EASY_TO_DESC(item.severity, 'EN')" size="sm" :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(item.severity, 'variant')">
          <!-- 영문 기준으로 모드 설정 필요 -->
          <b-dropdown-item
            size="sm"
            @click="() => { item.severity_origin = !item.severity_origin ? item.severity : item.severity_origin;  item.is_change = item.severity_origin != x; item.severity = x; }"
            v-for="(x, sindex) in codes.WAF_SEVERITYS_EASY"
            :key="'_mode'+sindex"
          >{{codes.WAF_SEVERITYS_EASY_TO_DESC(x, 'EN')}}</b-dropdown-item>
        </b-dropdown>
      </b-col>
      <b-col>
        <b-button :disabled="!item.policy" size="sm" class="bton btn-addition" @click="append" style="height: 50px">
          ポリシーを追加
        </b-button>
      </b-col>
    </b-row>
    <hr>
    <b-row v-if="!policy_list_custom || !policy_list_custom.length" class="text-center">
      <b-col>
        ポリシーが設定されていません
      </b-col>
    </b-row>
    <b-row v-for="(p, p_index) in policy_list_custom" :key="'_p' + p_index" class="text-center mt-2">
      <b-col>
        {{p.policy}}
      </b-col>
      <b-col>
        <!-- 모드 -->
        <b-dropdown :disabled="Boolean(is_preview)" style="width: 80%;" :text="codes.WAF_MODE_I18N(p.mode, 'EN')" size="sm" :variant="codes.WAF_MODE_TO_COLOR(p.mode, 'variant')">
          <!-- 영문 기준으로 모드 설정 필요 -->
          <b-dropdown-item
            size="sm"
            @click="() => change('mode', p_index, codes.WAF_MODE_INTERFACE(x))"
            v-for="(x, sindex) in codes.WAF_MODE"
            :key="'_mode'+sindex"
          >{{codes.WAF_MODE_I18N(x, 'EN')}}</b-dropdown-item>
        </b-dropdown>
        <span v-if="p.last_mode_updated_at && !p.last_mode_updated_at.startsWith('0001')" class="text-info m-2 d-inline-block" v-b-tooltip.hover :title="`このポリシーのモードは次のとおりです。 ${moment(p.last_mode_updated_at).format('YYYY-MM-DD HH:mm:ss')} 最終更新`">
          <i class="fas fa-question-circle"></i>
        </span>
      </b-col>
      <!-- TODO : 레벨은 향후 사용 예정 -->
      <!-- <b-col>

        레벨
      </b-col> -->
      <b-col>
        <!-- 위험도는 현재 커스텀 강제 적용 -->
        <b-dropdown :disabled="Boolean(is_preview)" style="width: 80%;" :text="codes.WAF_SEVERITYS_EASY_TO_DESC(p.severity, 'EN')" size="sm" :variant="codes.WAF_SEVERITY_TO_COLOR_EASY(p.severity, 'variant')">
          <!-- 영문 기준으로 모드 설정 필요 -->
          <b-dropdown-item
            size="sm"
            @click="() => change('severity', p_index, x)"
            v-for="(x, sindex) in codes.WAF_SEVERITYS_EASY"
            :key="'_mode'+sindex"
          >{{codes.WAF_SEVERITYS_EASY_TO_DESC(x, 'EN')}}</b-dropdown-item>
        </b-dropdown>
        <span v-if="p.last_serverity_updated_at && !p.last_serverity_updated_at.startsWith('0001')" class="text-info m-2 d-inline-block" v-b-tooltip.hover :title="`このポリシーのリスクは ${moment(p.last_serverity_updated_at).format('YYYY-MM-DD HH:mm:ss')} 最終更新`">
          <i class="fas fa-question-circle"></i>
        </span>
      </b-col>
      <b-col v-if="!is_preview || is_preview === false">
        <b-button size="sm" class="btn btn-danger" @click="remove(p_index)">
          リムーブ
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
